// Čist modul (ide i u klijentski bundle): normalizacija i provjera broja računa
// za isplatu terapeutu. Prihvata BiH transakcijski račun (16 cifara) ili IBAN.

const BIH_ACCOUNT_RE = /^\d{16}$/;
const IBAN_RE = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/;

export const BANK_ACCOUNT_ERROR = "Broj računa mora imati 16 cifara (ili unesi IBAN)";

/** Uklanja razmake i crtice i pretvara slova u velika: "161-000 0012345678" → "1610000012345678". */
export function normalizeBankAccount(raw: string): string {
  return raw.replace(/[\s-]+/g, "").toUpperCase();
}

/** Da li je (već normalizovan) broj BiH transakcijski račun ili IBAN. */
export function isValidBankAccount(normalized: string): boolean {
  return BIH_ACCOUNT_RE.test(normalized) || IBAN_RE.test(normalized);
}
